import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Box,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Divider, MotionAccordionPanel } from '@time-line/components/common';
import { Minus, Plus } from '@time-line/components/icons';
import type { NavGroup } from '@time-line/components/types';

import { NewsletterSignup } from '../NewsletterSignup';
import { NavLink } from './NavLink';

interface NavMobileProps {
  nav: NavGroup[];
}

export function NavMobile({ nav }: NavMobileProps) {
  return (
    <Accordion
      className="footer_nav-mobile"
      as="nav"
      aria-label="Footer"
      allowMultiple
      defaultIndex={[0]}
    >
      {nav.map(({ label, subNav }, i) => (
        <Box key={i}>
          <Divider />
          <AccordionItem key={i} border="none">
            {({ isExpanded }) => (
              <>
                <AccordionButton
                  px={0}
                  py="2xs"
                  justifyContent="space-between"
                  sx={{
                    '&:hover': { bgColor: 'initial' },
                  }}
                >
                  <Text as="span" size="overline">
                    {label}
                  </Text>
                  {isExpanded ? <Minus /> : <Plus />}
                </AccordionButton>

                <MotionAccordionPanel
                  px={0}
                  pt={{ base: 0, lg: 'sm' }}
                  pb="2xs"
                >
                  <Stack spacing="4xs" pb="4xs">
                    {subNav?.items.map(
                      (item, j) =>
                        item.href && (
                          <NavLink
                            key={j}
                            href={item.href}
                            isExternal={
                              'isExternal' in item &&
                              (item as { isExternal?: boolean }).isExternal
                            }
                            label={item.label}
                            name={item.name}
                            platform="mobile"
                            showIcon={
                              'showIcon' in item &&
                              (item as { showIcon?: boolean }).showIcon
                            }
                          />
                        ),
                    )}
                  </Stack>
                </MotionAccordionPanel>
              </>
            )}
          </AccordionItem>
        </Box>
      ))}
      <Divider />
      <NewsletterSignup />
    </Accordion>
  );
}
